module.exports = __webpack_public_path__ + "img/442497a5cb2b6c7697f0a3f8c186eb09.png";